//import { combineReducers } from 'redux';
import { createReducer, getType } from 'typesafe-actions';

import { spinnerStart, spinnerStop } from '../actions/spinner.actions';

const spinnerReducer = createReducer(false)
  .handleType(getType(spinnerStart), (state, action) => state = true)
  .handleType(getType(spinnerStop), (state, action) => state = false);

export default spinnerReducer;